import { supabase } from './customSupabaseClient.js';

class ServicesService {
  // Get all services
  async getServices() {
    try {
      const { data, error } = await supabase
        .from('services')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      
      // servicesService.getServices - data fetched
      
      if (data && data.length > 0) {
        // servicesService.getServices - first service info
      }
      
      return data || [];
    } catch (error) {
      console.error('Error fetching services:', error);
      throw error;
    }
  }

  // Add new service
  async addService(serviceData) {
    try {
      const { data, error } = await supabase
        .from('services')
        .insert([serviceData])
        .select()
        .maybeSingle();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error adding service:', error);
      throw error;
    }
  }

  // Update service
  async updateService(id, serviceData) {
    try {
      // servicesService.updateService called
      
      // First, check if the service exists
      const { data: existingService, error: checkError } = await supabase
        .from('services')
        .select('id, name')
        .eq('id', id)
        .maybeSingle();

      // Service existence check

      if (checkError) {
        console.error('❌ Error checking service existence:', checkError);
        throw checkError;
      }

      if (!existingService) {
        console.error('❌ Service not found with ID:', id);
        throw new Error(`Service with ID ${id} not found`);
      }

      // Service found, proceeding with update
      
      // Try RPC function first (bypasses RLS)
      if (serviceData.image_url) {
        // Trying RPC update
        const { data: rpcData, error: rpcError } = await supabase
          .rpc('update_service_image', { 
            service_id: id, 
            image_url: serviceData.image_url 
          });

        // RPC update result

        if (!rpcError && rpcData && !rpcData.error) {
          // RPC update successful
          return rpcData;
        } else {
          // RPC update failed, trying regular update
        }
      }
      
      // Fallback to regular update
      const { data, error } = await supabase
        .from('services')
        .update(serviceData)
        .eq('id', id)
        .select();

      // Regular update result

      if (error) {
        console.error('❌ Supabase error:', error);
        throw error;
      }
      
      if (!data || data.length === 0) {
        console.warn('⚠️ No data returned from update - service might not exist or update failed');
        // Return the original service data with the updated image_url
        return { ...existingService, ...serviceData };
      }
      
      // Update successful, returning updated service
      return data[0];
    } catch (error) {
      console.error('❌ Error updating service:', error);
      throw error;
    }
  }

  // Delete service
  async deleteService(id) {
    try {
      const { error } = await supabase
        .from('services')
        .delete()
        .eq('id', id);

      if (error) throw error;
      return true;
    } catch (error) {
      console.error('Error deleting service:', error);
      throw error;
    }
  }

  // Get service by ID
  async getServiceById(id) {
    try {
      const { data, error } = await supabase
        .from('services')
        .select('*')
        .eq('id', id)
        .maybeSingle();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error fetching service:', error);
      throw error;
    }
  }
}

export default new ServicesService();
